var exports = {
  "kL": "GuildModerationTab.module__container___OE83eU",
  "uW": "GuildModerationTab.module__section___OE83eU",
  "Gf": "GuildModerationTab.module__sectionTitle___OE83eU",
  "yV": "GuildModerationTab.module__sectionDescription___OE83eU",
};

module.exports = exports;
